import { useTranslation } from 'react-i18next'

import { Alert } from '@enechain/ecloud-designsystem'

/** 通常・ブロック共通の受渡日単位の警告 (AC-BSP-125)。 */
export const NeedsReviewBanner = ({
  count,
}: {
  count: number
}): React.ReactElement | null => {
  const { t } = useTranslation()
  if (count === 0) return null
  return (
    <Alert
      description={t('page:biddingSpot.needsReview.description')}
      status="warning"
      title={t('page:biddingSpot.needsReview.title', { count })}
    />
  )
}
